module.exports = __webpack_public_path__ + "static/img/cp.5dbee555.svg";